import styled from 'styled-components';

export const CgvViewWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 50px;
  h2, a {
    color: ${props => `${props.theme.color.primaryColor}`};
  }
`;
